import log from 'loglevel';
import { ApiService } from "./ApiService";
import { ApiEndpoints } from '@/constants/ApiEndpoints';
import { OffersAndPaging } from "@/interfaces/Offers/OffersAndPaging";
import { OffersParameters } from "@/interfaces/Offers/OffersParameters";
import { TokenRequiredStrategy } from "../strategies/TokenRequiredStrategy";
import { HomeFeedOffersResponse } from "@/interfaces/Offers/HomeFeedOffersResponse";
import { Offer } from "@/interfaces/Offers/Offer";

import { TabbedOffersResponse } from "@/interfaces/Offers/TabbedOffersResponse";





class OfferServiceClass extends ApiService {
	
	
	
	
	
	private OFFERS_ENDPOINT = ApiEndpoints.OFFERS;
	private RATE_OFFER_ENDPOINT = ApiEndpoints.RATE_OFFER;
	private START_OFFER_ENDPOINT = ApiEndpoints.START_OFFER;
	private REPORT_OFFER_ENDPOINT = ApiEndpoints.REPORT_OFFER;
	private OFFER_BY_ID_ENDPOINT = ApiEndpoints.OFFER_BY_ID;
	private DAILY_PICKS_ENDPOINT = ApiEndpoints.DAILY_PICKS;
	private DAILY_OFFERS_ENDPOINT = ApiEndpoints.DAILY_OFFERS;





	constructor() {
		super(TokenRequiredStrategy);
	}





	async getAllOffers(params: OffersParameters): Promise<OffersAndPaging> {
		try {
			const response = await this.get(this.OFFERS_ENDPOINT, params);
			return response;
		} catch (error) {
			log.error("Failed to get all offers:", error);
			throw error;
		}
	}


	async getOfferById(offerId: string | number): Promise<Offer> {
		try {
			// Use the new dedicated endpoint for getting an offer by ID
			const response = await this.get(`${this.OFFER_BY_ID_ENDPOINT}/${offerId}`);
			
			// Check if we got a valid response
			if (!response) {
				throw new Error(`Offer with ID ${offerId} not found`);
			}
			
			// Extract the offer data from the nested data property
			if (response.data) {
				return response.data;
			} else {
				throw new Error(`Invalid offer data structure for ID ${offerId}`);
			}
		} catch (error) {
			log.error(`Failed to get offer by ID ${offerId}:`, error);
			throw error;
		}
	}





	async startOffer(offerId: string, variantId: string): Promise<void> {
		try {
			this.openWindow(`${this.START_OFFER_ENDPOINT}/${offerId}/start`, {
				variant_id: variantId,
				web: '1',
				fromBrowser: true
			});
		} catch (error) {
			log.error("Failed to start offer:", error);
			throw error;
		}
	}





	async reportOffer(offerId: string, reasonCode: string): Promise<void> {
		try {
			const response = await this.post(
				`${this.REPORT_OFFER_ENDPOINT}/${offerId}/report`,
				{ reason: reasonCode }
			);
			return response;
		} catch (error) {
			log.error("Failed to report offer:", error);
			throw error;
		}
	}





	async rateOffer(offerId: string, rating: 'like' | 'dislike' | null) {
		try {
			const response = await this.post(
				`${this.RATE_OFFER_ENDPOINT}/${offerId}/rate`,
				{ rating }
			);
			return response;
		} catch (error) {
			log.error("Failed to rate offer:", error);
			throw error;
		}
	}





	async getDailyPicksOffers(params: object): Promise<HomeFeedOffersResponse> {
		try {
			const response = await this.get(this.DAILY_PICKS_ENDPOINT, params);
			return response;
		} catch (error) {
			log.error("Failed to get daily offers:", error);
			throw error;
		}
	}





	async getTabbedOffers(params: object): Promise<TabbedOffersResponse> {
		try {
			const response = await this.get(this.DAILY_OFFERS_ENDPOINT, params);
			return response;
		} catch (error) {
			log.error("Failed to get daily offers:", error);
			throw error;
		}
	}
}

// Export an instance of the OfferServiceClass class
const OfferService = new OfferServiceClass();
export { OfferService };
